import { Directive, ElementRef, Input, OnInit, Renderer2, inject } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[siriusAnchor]',
})
export class AnchorDirective implements OnInit {
    private _renderer = inject(Renderer2);
    private _elRef = inject(ElementRef);

    @Input() id = '';

    ngOnInit(): void {
        this._renderer.setAttribute(this._elRef.nativeElement, 'id', this.id);
    }
}
